export default __webpack_public_path__ + "images/LF.ddb4605.png";